module.exports = __webpack_public_path__ + "static/img/fellowChicken3.8f2aa6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fellowChicken3.png
// module id = GWtc
// module chunks = 2